import Loader from 'components/Loader'
import React, { lazy, Suspense } from 'react'
import { Route, Switch } from 'react-router-dom'

const BussinesSmart = lazy(async ()=>import('./bussinesSmart'))
const Metas = lazy(async ()=>import('./Metas'))
const Visor360 = lazy(async ()=>import('./Visor360'))
const Analitica = ({ match }: any) => {
    

  return (
    <div className="app-wrapper">
      <Switch>
        <Suspense fallback={<Loader />}>
        <Route path={`${match.url}/inteligencia-negocio`} component={BussinesSmart} />
        <Route path={`${match.url}/metas`} component={Metas} />
        <Route path={`${match.url}/visor-360`} component={Visor360} />
        </Suspense>
      </Switch>
    </div>
  )
}

export default Analitica
